import React from 'react';
import Responsive from 'react-responsive';

const Desktop = props => <Responsive {...props} minWidth={992} />;
const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={991} />;
const Mobile = props => <Responsive {...props} maxWidth={767} />;
const Default = props => <Responsive {...props} minWidth={768} />;

function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
}

export {
    Desktop,
    Tablet,
    Mobile,
    Default,
    isMobile
}


// WEBPACK FOOTER //
// ./src/common/ResponsiveUtils.js